import { render, staticRenderFns } from "./Incrementer.vue?vue&type=template&id=60483132&scoped=true&"
import script from "./Incrementer.vue?vue&type=script&lang=js&"
export * from "./Incrementer.vue?vue&type=script&lang=js&"
import style0 from "./Incrementer.vue?vue&type=style&index=0&id=60483132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60483132",
  null
  
)

export default component.exports